import { useInvoiceFormContext } from '@/components/Fiscal/Invoice/InvoiceFormProvider';
import {
  InvoiceProvider,
  InvoiceSituation,
} from '@/core/domain/invoice/invoices/invoices.enums';
import { Tooltip } from 'antd';
import { Info } from 'react-feather';

export enum InvoiceDocument {
  xmlMirror = 'xml-mirror',
  pdfMirror = 'pdf-mirror',
  xml = 'xml',
  pdf = 'pdf',
  pdfRps = 'pdfRps',
  uploadFile = 'uploadFile',
}

export const InvoiceDocumentTypeMapper = {
  [InvoiceDocument.pdf]: 'PDF',
  [InvoiceDocument.pdfRps]: 'PDF',
  [InvoiceDocument.pdfMirror]: 'PDF',
  [InvoiceDocument.xml]: 'XML',
  [InvoiceDocument.xmlMirror]: 'XML',
  [InvoiceDocument.uploadFile]: 'TXT',
};

export const InvoiceDocumentTranslation = {
  [InvoiceDocument.xmlMirror]: 'Espelho-do-XML',
  [InvoiceDocument.pdfMirror]: 'Espelho-do-PDF',
  [InvoiceDocument.xml]: 'XML',
  [InvoiceDocument.pdf]: 'PDF',
  [InvoiceDocument.pdfRps]: 'RPS/PDF',
  [InvoiceDocument.uploadFile]: 'Arquivo da prefeitura',
};

interface InvoiceDocumentOptionsParams {
  isNfs: boolean;
  isBhSpCity: boolean;
  handleDisabledMirrorXmlPdf: boolean;
  handleDisabledXmlPdf: boolean;
  invoiceSituation?: InvoiceSituation;
}

export const getInvoiceDocumentOptions = ({
  isNfs,
  isBhSpCity,
  handleDisabledMirrorXmlPdf,
  handleDisabledXmlPdf,
  invoiceSituation,
}: InvoiceDocumentOptionsParams) => {
  const { companyProvider, isInternalApiIssued } = useInvoiceFormContext();

  const toolTipLabel = (
    <Tooltip
      title="Se o seu provedor realizar a autorização das notas por meio de upload em lote, será necessário fazer o download desse arquivo."
      placement="left"
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        Arquivo de autorização <Info size={20} cursor="pointer" />
      </span>
    </Tooltip>
  );

  const uploadFileProviders = [
    InvoiceProvider.DATAPUBLIC,
    InvoiceProvider.CEBIUP,
  ];

  return [
    {
      label: 'Pre-visualização do XML',
      value: InvoiceDocument.xmlMirror,
      disabled: handleDisabledMirrorXmlPdf || (isNfs && !isBhSpCity),
      viewButton: true,
      downloadButton: true,
    },
    {
      label: 'Pre-visualização do PDF',
      value: InvoiceDocument.pdfMirror,
      disabled: handleDisabledMirrorXmlPdf || (isNfs && !isBhSpCity),
      viewButton: true,
      downloadButton: true,
    },
    {
      label: 'XML',
      value: InvoiceDocument.xml,
      disabled: handleDisabledXmlPdf,
      viewButton: true,
      downloadButton: true,
    },
    {
      label: 'PDF',
      value: InvoiceDocument.pdf,
      disabled: handleDisabledXmlPdf,
      viewButton: true,
      downloadButton: true,
    },
    {
      label: 'RPS/PDF',
      value: InvoiceDocument.pdfRps,
      disabled: !isNfs || invoiceSituation !== InvoiceSituation.PROCESSING,
      viewButton: true,
      downloadButton: true,
    },
    {
      label: toolTipLabel,
      value: InvoiceDocument.uploadFile,
      disabled: !(
        isNfs &&
        !isInternalApiIssued &&
        invoiceSituation === InvoiceSituation.AUTHORIZED &&
        uploadFileProviders.includes(
          companyProvider?.provider as InvoiceProvider,
        )
      ),
      viewButton: true,
      downloadButton: true,
    },
  ];
};
